import request from './index';

// 登录
export function userLogin(data) {
  return request({
    url: '/api/user/login',
    method: 'post',
    data,
  });
}
// 告警管理
export function warningPage(data) {
  return request({
    url: '/api/baihetan/v1/warning/page',
    method: 'post',
    data,
  });
}

// 在囚人员列表
export function personPage(data) {
  return request({
    url: '/api/baihetan/v1/person/page',
    method: 'post',
    data,
  });
}

// 获取配置
export function configDistance(data) {
  return request({
    url: '/api/baihetan/v1/distance/config',
    method: 'post',
    data,
  });
}

// 设置配置
export function setDistance(data) {
  return request({
    url: '/api/baihetan/v1/distance/set',
    method: 'post',
    data,
  });
}

// 获取人员位置
export function infoGet(data) {
  return request({
    url: '/api/baihetan/v1/distance/info/get',
    method: 'post',
    data,
  });
}
